module.exports = __webpack_public_path__ + "static/media/image-currency.0f583e2b.jpg";